/**
 * Step state for `AnnotationStepBar`. Mirrors the visual states from
 * `feature-spec.md` §3.4.1:
 *   - pending  : not yet visited
 *   - active   : currently being annotated
 *   - complete : visited AND satisfied (≥1 label OR "none apply" toggled)
 */
export type StepState = 'pending' | 'active' | 'complete';

export interface ComputeStepStatesArgs {
  totalSteps: number;
  currentStep: number;
  /** Set of step indices the user has navigated to (including the current). */
  visited: Set<number>;
  /** Set of step indices whose data is satisfied (≥1 label OR none-apply on). */
  satisfied: Set<number>;
}

/**
 * Compute the visual state for each step index.
 *
 * - current step → `active`
 * - visited + satisfied → `complete`
 * - otherwise → `pending`
 */
export const computeStepStates = ({
  totalSteps,
  currentStep,
  visited,
  satisfied,
}: ComputeStepStatesArgs): StepState[] => {
  const out: StepState[] = [];
  for (let i = 0; i < totalSteps; i++) {
    if (i === currentStep) {
      out.push('active');
    } else if (visited.has(i) && satisfied.has(i)) {
      out.push('complete');
    } else {
      out.push('pending');
    }
  }
  return out;
};
